import ErrorsHelper from "@/_helpers/ErrorsHelper.js";

export default new (class MenuHelper {
  constructor() {
    this.Categories = ["dashboard", "home"];
    this.CategoryIcons = {
      dashboard: "scf-dashboard",
      home: "scf-patrimoine",
    };
    this.ArrangedMenu = [];
  }

  TranslateMenu(appReference) {
    this.TranslateMenuItems(this.ArrangedMenu, appReference);
  }

  TranslateMenuItems(menuItems, appReference) {
    for (let menuItem of menuItems) {
      this.TranslateMenuItem(menuItem, appReference);
      if (menuItem.child) this.TranslateMenuItems(menuItem.child, appReference);
    }
  }

  TranslateMenuItem(menuItem, appReference) {
    if (menuItem.tcode) {
      delete menuItem.title;
      menuItem.title = appReference.$t(`sideBar.${menuItem.tcode}`);
    }
  }

  GetArrangedMenu(uncategorizedItems) {
    this.SortByPriority();
    this.AddUncategorizedItems(uncategorizedItems);
    return this.ArrangedMenu;
  }

  SortByPriority() {
    for (let categorizedItem of this.ArrangedMenu) {
      if (!categorizedItem.child) continue;

      categorizedItem.child.sort((a, b) =>
        a.category && b.category
          ? a.category.priority - b.category.priority
          : true
      );
    }
  }

  AddUncategorizedItems(uncategorizedItems) {
    uncategorizedItems.forEach((item) => {
      if (
        item.icon &&
        item.icon.class &&
        item.icon.class.includes("vsm--header-icon")
      ) {
        this.ArrangedMenu.unshift(item);
      } else {
        this.ArrangedMenu.push(item);
      }
    });
  }

  PushToCategory(menuItem, categoryTitle) {
    if (this.IsCategoryPushed(menuItem.category.code)) {
      for (let categoryItem of this.ArrangedMenu) {
        if (categoryItem.category === menuItem.category.code) {
          if (!menuItem.category.priority || menuItem.category.priority == null)
            menuItem.category.priority = Number.MAX_SAFE_INTEGER;
          categoryItem.child.push(this.AdjustMenuItem(menuItem));
          break;
        }
      }
    } else {
      if (this.CategoryExists(menuItem.category.code)) {
        this.PushCategory(menuItem.category.code, categoryTitle);
        this.PushToCategory(menuItem, categoryTitle);
      } else {
        ErrorsHelper.UnkownCategoryCode(menuItem, this.Categories);
      }
    }
  }

  AdjustMenuItem(menuItem) {
    menuItem.icon = null;
    return menuItem;
  }

  PushCategory(category, title) {
    const placeHolder = {
      category: category,
      href: "",
      title: title,
      exact: false,
      external: false,
      icon: {
        element: "i",
        class: this.CategoryIcons[category],
        attributes: { style: "font-size: xx-large;" },
      },
      child: [],
    };
    return this.ArrangedMenu.push(placeHolder);
  }

  ItemHasCategory(menuItem) {
    return (
      menuItem.category !== undefined &&
      menuItem.category !== null &&
      menuItem.category.code
    );
  }

  CategoryExists(categoryCode) {
    return this.Categories.filter((el) => el == categoryCode).length > 0;
  }

  IsCategoryPushed(categoryCode) {
    return (
      this.ArrangedMenu.filter((el) => el.category == categoryCode).length > 0
    );
  }
})();
